import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSocialLinks = () => {
  const [socialLinks, setSocialLinks] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(`${API}/social-links`);
        setSocialLinks(response.data);
      } catch (err) {
        // Fallback to default links
        setSocialLinks({
          instagram: { url: "https://instagram.com/calli_phone", enabled: true },
          facebook: { url: "https://facebook.com/calliphone", enabled: true },
          tiktok: { url: "https://tiktok.com/@calli_phone", enabled: true },
          youtube: { url: "https://youtube.com/@calli_phone", enabled: true },
          twitter: { url: "https://twitter.com/calli_phone", enabled: true },
          linkedin: { url: "https://linkedin.com/company/calli-phone", enabled: true },
        });
      } finally {
        setLoading(false);
      }
    };
    fetchLinks();
  }, []);

  return { socialLinks, loading };
};
